import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CandidatesManagementRoutingModule } from './candidates-management-routing.module';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxMaskModule } from 'ngx-mask';
import { ViewComponent } from './view/view.component';
import { MatMenuModule } from '@angular/material/menu';
import { QuillModule } from 'ngx-quill';


@NgModule({
  declarations: [
    AddComponent,
    ListComponent,
    ViewComponent,
  ],
  imports: [
    CommonModule,
    CandidatesManagementRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot(),
    MatMenuModule,
    QuillModule.forRoot(),
  ]
})
export class CandidatesManagementModule { }
